export const modalContentHeight = '470px';
export const modalContentWidth = '500px';
export const SEARCH_DEBOUNCE_DELAY = 200;
export const MINIMUM_COUNT_FOR_SEARCHBAR = 4;
